import { render, staticRenderFns } from "./薪资发放.vue?vue&type=template&id=2c650110&scoped=true&"
import script from "./薪资发放.vue?vue&type=script&lang=js&"
export * from "./薪资发放.vue?vue&type=script&lang=js&"
import style0 from "./薪资发放.vue?vue&type=style&index=0&id=2c650110&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c650110",
  null
  
)

export default component.exports